import { Tag } from '../../cdl/Tag/Tag';
import { OfferState } from '../../offer/model/OfferState';
import { translate } from '../helpers/translate.helper';

import { getStateEmphasis, getStateVariant } from './offerStatusTagHelpers';

type OfferStatusTagProps =
    | {
          state: OfferState;
          variant: 'customer';
      }
    | {
          state: OfferState;
          variant: 'supplier';
          kycRequested?: boolean;
      };

export const OfferStatusTag = (props: OfferStatusTagProps) => {
    if (props.variant === 'supplier' && props.kycRequested && props.state === OfferState.QUOTED) {
        return <Tag variant="attention">{translate('supplierOnboarding.tag.requested')}</Tag>;
    }

    return (
        <Tag
            variant={getStateVariant(props.state, props.variant)}
            emphasis={getStateEmphasis(props.state, props.variant)}
        >
            {translate(`state.LUBES.${props.state}.title`)}
        </Tag>
    );
};
